import { render, staticRenderFns } from "./workflow.vue?vue&type=template&id=22b8f08e&"
import script from "./workflow.vue?vue&type=script&lang=js&"
export * from "./workflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports